import React from "react";

export default function UpdateProgressIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <rect
        x="1"
        y="6"
        width="9"
        height="3.5"
        rx="1.75"
        stroke="currentColor"
        strokeWidth="1"
      />
      <rect x="1" y="6" width="5" height="3.5" rx="1.75" fill="currentColor" />
      <path
        d="M9.5 5 L13 1.5"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinecap="round"
      />
      <path d="M8.4 6.1 L9.5 5 L9.9 6 Z" fill="currentColor" />
    </svg>
  );
}
